import { ActionsTypes } from "./actions";
import { ActionTypes as PageActionsTypes } from "../../pages/actions";

const masavExportsReducer = (state = {
    error: false,
    loading: false,
    masavExports: [],
    masavExportsCount: 0,
    currentExport: null,
    isSubmitting: false,
    uploadSuccess: false,
}, action) => {
    let newState;
    let { payload, type } = action;
    
    switch (type) {
        case ActionsTypes.FETCH_MASAV_EXPORTS_REQUEST:
            newState = { ...state, loading: true, error: false }
            break;
        case ActionsTypes.FETCH_MASAV_EXPORTS_SUCCESS:
            newState = { 
                ...state, 
                loading: false, 
                masavExports: payload.data[0],
                masavExportsCount: payload.data[1]
            }
            break;
        case ActionsTypes.FETCH_MASAV_EXPORTS_FAILURE:
            newState = { ...state, loading: false, error: true }
            break;

        case ActionsTypes.FETCH_SINGLE_MASAV_EXPORT_REQUEST:
            newState = { ...state, loading: true, error: false }
            break;
        case ActionsTypes.FETCH_SINGLE_MASAV_EXPORT_SUCCESS:
            newState = { ...state, loading: false, currentExport: payload }
            break;
        case ActionsTypes.FETCH_SINGLE_MASAV_EXPORT_FAILURE:
            newState = { ...state, loading: false, error: true }
            break;

        case ActionsTypes.UPLOAD_CONFIRMATION_REQUEST:
            newState = { ...state, isSubmitting: true, uploadSuccess: false, error: false }
            break;
        case ActionsTypes.UPLOAD_CONFIRMATION_SUCCESS:
            newState = { ...state, isSubmitting: false, uploadSuccess: true }
            break;
        case ActionsTypes.UPLOAD_CONFIRMATION_FAILURE:
            newState = { ...state, isSubmitting: false, error: true }
            break;

        case PageActionsTypes.MASAV_EXPORTS_PAGE_MOUNTED:
            newState = { ...state, uploadSuccess: false, error: false }
            break;

        default:
            newState = state;
    }
    return newState;
}

export default masavExportsReducer;

